import React, { useContext, useState } from "react";
import { Box, SpanStyled, SubHeadingStyled } from "../../../components/styled/Elements";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DataContainer, ProfileSidebarWrapper, ProfileWrapper } from "./styled";
import { LogoutIcon} from "../../../components/styled/AllImages";
import { tabsArrayList } from "./TabsArray";
import { Link } from "react-router-dom";
import LogoutModal from "../../../components/admin/Modals/LogoutModal/LogoutModal";


const Profile = () => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState(tabsArrayList[0]);
    const [showLogout, setShowLogout] = useState(false);
    
    const onLogout = () => {
        setShowLogout(true);
    };
	return (
		<ProfileWrapper>
			<Box className="content-head">
				<SubHeadingStyled size="16px" weight="700" color="var(--text)">
					{t("Profile")}
				</SubHeadingStyled>
			</Box>
			<Box className="content-container">
				<Row className="mt-3">
					<Col md={12}>
						<DataContainer className="dataContainer">
							<ProfileSidebarWrapper>
								<Box className="text-center">
									<Box className="sidebar-list custom-scroll">
										<ul className="list-unstyled mb-0 pt-3">
											{tabsArrayList.map((item, key) => (
												<li
													className={` mb-2 ${
													item.title === activeTab.title ? "active" : ""
													}`}
													onClick={() => setActiveTab(tabsArrayList[key])}
													key={key}
												>
													<Link 
														className={`text-decoration-none d-flex align-items-center`}
													>
														<Box className="list-icon mx-2">
															<item.icon />
															
														</Box>
														<Box>
															<SpanStyled
																className="text-capitalize d-flex"
															>
																{t(item.title)}
															</SpanStyled>
														</Box>
													</Link>
													
												</li>
											))}
											<li	className="mb-2 logout-tab">
                                                <Link 
                                                    className={`text-decoration-none d-flex align-items-center`}
                                                    onClick={onLogout}
                                                >
                                                    <Box className="list-icon mx-2">
                                                        <LogoutIcon />
                                                        
                                                    </Box>
                                                    <Box>
                                                        <SpanStyled
                                                            className="text-capitalize d-flex"
                                                            color="var(--redColor)"
                                                        >
                                                            {t('Logout')}
                                                        </SpanStyled>
                                                    </Box>
                                                </Link>
                                                
                                            </li>
										</ul>
									</Box>
								</Box>
							</ProfileSidebarWrapper>
							
							<Box className="profileContent">
								<activeTab.component />
							</Box>
						</DataContainer>
					</Col>
				</Row>
			</Box>
            <LogoutModal
                show={showLogout}
                onHide={() => setShowLogout(false)}
            />
		</ProfileWrapper>
	);
};

export default Profile;
